import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import posthog from 'posthog-js';
import 'leaflet/dist/leaflet.css';
import './index.css';
import App from './App.jsx';

// Sentry — crashes + handled errors. DSN from Cloudflare Pages env var.
// With no VITE_SENTRY_DSN set, enabled:false short-circuits all calls.
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
  environment: import.meta.env.MODE,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
});

// PostHog — product/usage analytics. Key from Cloudflare Pages env var.
// person_profiles:'identified_only' means anonymous visitors don't create
// profiles (cost control). Session recording is on by default.
if (import.meta.env.VITE_POSTHOG_KEY) {
  posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
  });
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
